import administrator from './admin';
import {admin_exams} from './exams';

export const getAdminMenuItems = () => {
  return {
    items: [administrator, admin_exams]
  };
};
